export default {
  name: 'ItemCustomizations',

  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
